/**
 * Manipula los datos de la llamada, en este caso, detectamos el tipo de landing y en función de eso se carga uno u otro script
 */

import { loadScript } from './loadScript'

const DICTIONARY_CASES = {
  LANDINGS: 'landings',
  GENERALI: 'generali',
  SALUD: 'salud'
}

export function handleResponse(data) {
  if (typeof data === 'undefined') {
    return loadScript('https://t.womtp.com/slider/c/generali/landings.js')
  }
  const { type } = data
  console.log(type)
  console.log(data)

  if (type === DICTIONARY_CASES.LANDINGS) {
    return loadScript('https://t.womtp.com/slider/c/generali/landings.js')
  }
  if (type === DICTIONARY_CASES.GENERALI) {
    return loadScript('https://t.womtp.com/slider/c/generali/generali.js')
  }
  if (type === DICTIONARY_CASES.SALUD) {
    return loadScript(
      'https://t.womtp.com/slider/c/generali/new_refactor/landings/salud_landing.js'
    )
  }
}
